import React from "react";

const getStatusStyles = (statusName = "") => {
    const name = statusName.toLowerCase();

    if (name.includes("completed") || name.includes("paid")) {
        return {
            bg: "#10B981", // cs-success
            label: statusName,
        };
    }

    if (name.includes("pending")) {
        return {
            bg: "#F59E0B", // cs-warning
            label: statusName,
        };
    }

    if (name.includes("failed") || name.includes("rejected")) {
        return {
            bg: "#EF4444", // cs-danger
            label: statusName,
        };
    }

    return {
        bg: "#6B7280", // cs-muted
        label: statusName || "Unknown",
    };
};

const Columns = (navigate) => [
    {
        id: "id",
        name: "ID",
        minWidth: "70px",
        selector: (row) => row.id,
        cell: (row) => (
            <span className=" font-mono text-cs-muted">
                #{row.id}
            </span>
        ),
    },
    {
        id: "name",
        name: "CLIENT",
        minWidth: "160px",
        cell: (row) => (
            <div className="flex flex-col leading-tight">
                <span className=" font-semibold text-cs-dark">
                    {row.client?.contact_name || "-"}
                </span>
                <span className="text-sm text-cs-muted">
                    {row.client?.name || ""}
                </span>
            </div>
        ),
    },
    {
        id: "payment_date",
        name: "PAYMENT DATE",
        minWidth: "130px",
        selector: (row) => row.created_at,
        cell: (row) => (
            <span className=" text-cs-muted">
                {row.created_at || "-"}
            </span>
        ),
    },
    {
        id: "total",
        name: "AMOUNT",
        minWidth: "110px",
        selector: (row) =>
            new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
            }).format(row.total),
        cell: (row) => (
            <span className="font-semibold text-cs-primary-dark">
                {new Intl.NumberFormat("en-US", {
                    style: "currency",
                    currency: "USD",
                }).format(row.total)}
            </span>
        ),
    },
    {
        id: "status",
        name: "STATUS",
        minWidth: "110px",
        cell: (row) => {
            const { bg, label } = getStatusStyles(row.status?.name);
            return (
                <span
                    className="
                        px-2 py-0.5 rounded-full
                        font-medium text-white
                        inline-flex items-center gap-1
                    "
                    style={{ backgroundColor: bg }}
                >
                    <span className="w-1.5 h-1.5 rounded-full bg-white/90" />
                    {label}
                </span>
            );
        },
    },
    {
        id: "actions",
        name: "",
        button: true,
        right: true,
        minWidth: "110px",
        cell: (row) => (
            <div className="flex items-center justify-end gap-1.5">
                {/* (Opcional) placeholder editar - ahora solo UI */}
                <button
                    type="button"
                    onClick={() => console.log("Edit payment", row.id)}
                    className="
                        p-1.5 rounded-lg
                        text-cs-muted
                        hover:bg-cs-primary-soft
                        hover:text-cs-primary
                        transition-colors
                    "
                    title="Edit payment"
                >
                    <span className="material-symbols-outlined text-[16px]">
                        edit
                    </span>
                </button>

                {/* (Opcional) delete controlado por permisos si lo activas en el futuro */}
                <button
                    type="button"
                    onClick={() => console.log("Delete payment", row.id)}
                    disabled={!row.can?.delete}
                    className={`
                        p-1.5 rounded-lg
                        transition-colors
                        ${
                            row.can?.delete
                                ? "text-cs-danger hover:bg-cs-danger/5"
                                : "text-cs-muted opacity-40 cursor-not-allowed"
                        }
                    `}
                    title={
                        row.can?.delete
                            ? "Delete payment"
                            : "You cannot delete this payment"
                    }
                >
                    <span className="material-symbols-outlined text-[16px]">
                        delete
                    </span>
                </button>

                {/* Details */}
                <button
                    type="button"
                    onClick={() => navigate(`/payment-details/${row.id}`)}
                    className="
                        p-1.5 rounded-lg
                        text-cs-primary
                        hover:bg-cs-primary-soft
                        hover:text-cs-primary-dark
                        transition-colors
                    "
                    title="View invoice details"
                >
                    <span className="material-symbols-outlined text-[16px]">
                        visibility
                    </span>
                </button>
            </div>
        ),
    },
];

export default Columns;
